(function (root) {
  'use strict';
  const POLICY_VERSION = 'drop-insights-2026-09-v1';
  function endpoint(base) {
    if (typeof base !== 'string' || !base.trim()) return null;
    try {
      const url = new URL(base);
      if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || /^(localhost|127\.|\[|0\.)/i.test(url.hostname)) return null;
      return `${url.href.replace(/\/+$/, '')}/api/public/events`;
    } catch { return null; }
  }
  function consentSource(config, shopify, explicit) {
    if (config?.insightsEnabled !== true || config.privacyReady !== true || config.localPreview === true || !endpoint(config.controlApiUrl)) return null;
    try {
      if (typeof shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function') return shopify.customerPrivacy.analyticsProcessingAllowed() === true ? 'shopify' : null;
    } catch { return null; }
    return explicit === true ? 'explicit' : null;
  }
  function eventPayload(kind, id, catalogue, config, source, eventId) {
    if (!['view', 'save', 'interest'].includes(kind) || !['shopify', 'explicit'].includes(source) || !/^[A-Za-z0-9_-]{16,80}$/.test(eventId || '')) return null;
    const item = (Array.isArray(catalogue) ? catalogue : []).find((product) => product.id === id && !product.archiveOnly && !product.rightsReview);
    if (!item) return null;
    const result = { kind, catalogueId: item.id, eventId, consent: true, consentSource: source, policyVersion: POLICY_VERSION };
    if (/^[A-Z]{2}$/.test(config?.nativeCountry || '')) { result.country = config.nativeCountry; result.countrySource = 'shopify_localization'; }
    return result;
  }
  const api = { POLICY_VERSION, endpoint, consentSource, eventPayload };
  root.HEIRInsights = api;
  if (typeof document === 'undefined') return;
  const config = root.HEIR || {};
  let explicit = false;
  let serverAllowed = false;
  let serverReady = Promise.resolve(false);
  let lastWindow = 0; let sent = 0;
  api.setExplicitConsent = (value) => { explicit = value === true; };
  const target = endpoint(config.controlApiUrl);
  // Config reads send no behavioural signal. Flags must be explicitly enabled on both sides.
  if (target && config.insightsEnabled === true && config.privacyReady === true && config.localPreview !== true) {
    serverReady = fetch(target.replace(/\/events$/, '/field-notes/config'), { credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null).then((body) => { serverAllowed = body?.analyticsEnabled === true && body.analyticsPolicyVersion === POLICY_VERSION; return serverAllowed; }).catch(() => false);
  }
  api.track = async (kind, id) => {
    const source = consentSource(config, root.Shopify, explicit);
    if (!serverAllowed || !source || !root.crypto?.randomUUID) return false;
    const runtime = await root.HEIREdit?.ready;
    // Recheck permission after awaiting; a privacy preference can change at any time.
    if (consentSource(config, root.Shopify, explicit) !== source) return false;
    const now = Date.now(); if (now - lastWindow > 60000) { lastWindow = now; sent = 0; }
    if (sent >= 30) return false;
    const payload = eventPayload(kind, id, runtime?.catalogue, config, source, root.crypto.randomUUID());
    if (!payload) return false;
    sent++;
    try {
      const response = await fetch(target, { method: 'POST', credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      return response.ok;
    } catch { return false; }
  };
  // A rendered product page is one design view. Only a visitor already permitting
  // analytics at render time is eligible; later opt-in never backfills this view.
  const productHandle = document.querySelector('[data-heir-product]')?.dataset.heirDesignHandle;
  const permissionAtRender = consentSource(config, root.Shopify, explicit);
  if (productHandle && permissionAtRender) {
    Promise.all([serverReady, root.HEIREdit?.ready]).then(([allowed, runtime]) => {
      if (!allowed || consentSource(config, root.Shopify, explicit) !== permissionAtRender) return;
      const item = root.HEIREdit?.resolveDesign?.(productHandle, runtime?.catalogue);
      if (item) api.track('view', item.id);
    }).catch(() => {});
  }
})(typeof window !== 'undefined' ? window : globalThis);
